import React from 'react';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { pricing } from '../data/content';
import { trackViewItem, trackCTAClick } from '../lib/ga4';

const Pricing = () => {
  const handleOfferClick = (offer) => {
    const price = offer.price === 'Sur devis' ? 0 : parseInt(offer.price.replace(/\s/g, ''));
    trackViewItem(offer.name, price);
    trackCTAClick(`pricing_${offer.name.toLowerCase()}`, 'pricing_section');
  };

  return (
    <section
      id="offres"
      className="py-16 md:py-24 bg-white"
      data-testid="pricing-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2
            className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900 mb-4"
            style={{ letterSpacing: '-0.04em' }}
          >
            Nos offres
          </h2>
          <p className="text-lg text-gray-600">
            Des formules adaptées à chaque étape de votre transformation. 
            Toutes nos formations sont éligibles aux financements OPCO.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {pricing.map((offer, index) => (
            <div
              key={index}
              className={`relative flex flex-col p-8 bg-white rounded-2xl transition-all duration-300 ${
                offer.featured
                  ? 'border-2 border-[#1C2E4A] ring-2 ring-blue-100 shadow-xl scale-105 z-10'
                  : 'border border-gray-200 hover:shadow-lg hover:border-gray-300'
              }`}
              data-testid={`pricing-card-${index}`}
            >
              {/* Featured badge */}
              {offer.featured && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-[#1C2E4A] text-white text-sm font-medium px-4 py-1 rounded-full">
                    Recommandé
                  </span>
                </div>
              )}

              {/* Header */}
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {offer.name}
                </h3>
                <div className="flex items-baseline justify-center gap-1">
                  <span className="text-4xl font-black text-gray-900">
                    {offer.price}
                  </span>
                  {offer.period && (
                    <span className="text-gray-500 text-sm">€ {offer.period}</span>
                  )}
                </div>
                <p className="mt-2 text-sm text-gray-600">
                  {offer.description}
                </p>
              </div>

              {/* Features */}
              <ul className="space-y-4 mb-8 flex-grow">
                {offer.features.map((feature, featureIndex) => (
                  <li
                    key={featureIndex}
                    className="flex items-start gap-3"
                  >
                    <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-3 h-3 text-green-600" />
                    </div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <a
                href="#formulaire"
                onClick={() => handleOfferClick(offer)}
                className="block"
              >
                <Button
                  className={`w-full rounded-full py-3 transition-all active:scale-[0.98] ${
                    offer.featured
                      ? 'bg-[#1C2E4A] hover:bg-[#0F1E33] text-white'
                      : 'bg-white border border-gray-200 text-gray-900 hover:bg-gray-50'
                  }`}
                  data-testid={`pricing-cta-${index}`}
                >
                  {offer.cta}
                </Button>
              </a>
            </div>
          ))}
        </div>

        {/* Additional info */}
        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Besoin d'une offre sur mesure ?{' '}
            <a href="#formulaire" className="font-semibold hover:underline" style={{ color: '#1C2E4A' }}>
              Contactez-nous
            </a>
          </p>
          <p className="mt-2 text-sm text-gray-500">
            Tous les tarifs sont HT. Financement OPCO possible selon éligibilité.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
